import { IsBoolean, IsFQDN, IsNotEmpty, IsString, ValidateNested, IsOptional } from 'class-validator';
import { Type } from 'class-transformer';

import { IsEmailDomainUnique } from './validation/isEmailDomainUniqueValidator';

export enum EmailDomainType {
  HybridMailgunSMTPAccountType = 'HYBRID_MAILGUN_SMTP',
  MailgunAccountType = 'MAILGUN',
}

class EmailDomain {
  id: string;

  @IsString()
  type: EmailDomainType;

  @ValidateNested()
  @Type(() => EmailDomainContent)
  @IsEmailDomainUnique()
  content: EmailDomainContent;

  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export enum EmailDomainState {
  ACTIVE = 'active',
  UNVERIFIED = 'unverified',
  DISABLED = 'disabled',
}

class EmailDomainContent {
  @IsString()
  @IsFQDN({}, { message: 'Enter a valid domain.' })
  @IsNotEmpty({ message: 'Enter a valid domain.' })
  customerDomain: string;

  @IsString()
  @IsOptional()
  inboundDomain?: string;

  @IsOptional()
  @IsBoolean()
  isGladlyAccount?: boolean;

  @ValidateNested({ each: true })
  @Type(() => DnsRecord)
  @IsOptional()
  sendingDNSRecords?: DnsRecord[];

  @IsString()
  @IsOptional()
  state?: EmailDomainState;

  @IsOptional()
  withLegacyForwardingSetup?: boolean;
}

export enum DnsRecordType {
  TXT = 'TXT',
  CNAME = 'CNAME',
}

export class DnsRecord {
  type: string;
  recordType: DnsRecordType;
  valid: boolean;
  value: string;
}

export const DefaultEmailDomainConfiguration = Object.freeze({
  type: EmailDomainType.MailgunAccountType,
  content: {
    customerDomain: '',
    state: EmailDomainState.UNVERIFIED,
  },
});

export type EmailWithDomain = {
  emailLocalPart: string;
  emailDomain: string;
};

export default EmailDomain;
